import { Component } from '@angular/core';
import { AuthService } from '@core/auth';

interface MenuItem {
    name?: string;
    icon?: string;
    route?: string;
    accessControl?: string;
    subtitle?: string;
}

@Component({
    selector: '[sidebar]',
    standalone: false,
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.css',
})
export class SidebarComponent {
    constructor(public authService: AuthService) {}

    menu: MenuItem[] = [
        // {
        //     name: 'Inicio',
        //     icon: 'house-door',
        //     route: '/',
        // },
        {
            name: 'Médicos',
            icon: 'people',
            route: '/doctors',
            accessControl: 'ARIEL_ADMIN',
        },
        {
            name: 'Consultas',
            icon: 'heart-pulse',
            route: '/consultations',
            accessControl: 'ARIEL_DOCTOR',
        },
        {
            name: 'Configurações',
            icon: 'gear',
            route: '/configurations',
            accessControl: 'ARIEL_ADMIN',
        },
        // {
        //     subtitle: 'Setup',
        //     accessControl: 'ADMIN'
        // },
    ];
}
